(function () {
  var PASSPORT_KEY = 'popSnaxSnackPassportV1';
  var RESPONSE_KEY = 'popSnaxStoryResponsesV1';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function readStore(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || '{}'); }
    catch (error) { return {}; }
  }

  function writeStore(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (error) { return false; }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function updatePassportCount() {
    var count = Object.keys(readStore(PASSPORT_KEY)).length;
    document.querySelectorAll('[data-passport-count]').forEach(function (node) { node.textContent = count; });
  }

  function initResponse() {
    document.querySelectorAll('[data-story-response]').forEach(function (panel) {
      var key = panel.getAttribute('data-story-key');
      var saved = readStore(RESPONSE_KEY)[key];
      var buttons = panel.querySelectorAll('[data-response-value]');
      var thanks = panel.querySelector('[data-response-thanks]');
      function select(value) {
        buttons.forEach(function (button) {
          var active = button.getAttribute('data-response-value') === value;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (thanks) thanks.hidden = !value;
      }
      if (saved) select(saved);
      panel.addEventListener('click', function (event) {
        var button = event.target.closest('[data-response-value]');
        if (!button) return;
        var responses = readStore(RESPONSE_KEY);
        responses[key] = button.getAttribute('data-response-value');
        writeStore(RESPONSE_KEY, responses);
        select(responses[key]);
      });
    });
  }

  function initStamp() {
    document.querySelectorAll('[data-passport-stamp]').forEach(function (panel) {
      var handle = panel.getAttribute('data-story-handle');
      var buttons = panel.querySelectorAll('[data-passport-status]');
      var confirmation = panel.querySelector('[data-passport-confirmation]');
      function select(status) {
        buttons.forEach(function (button) {
          var active = button.getAttribute('data-passport-status') === status;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (confirmation) confirmation.hidden = !status;
      }
      var saved = readStore(PASSPORT_KEY)[handle];
      if (saved) select(saved.status);
      panel.addEventListener('click', function (event) {
        var button = event.target.closest('[data-passport-status]');
        if (!button) return;
        var passport = readStore(PASSPORT_KEY);
        passport[handle] = {
          handle: handle,
          title: panel.getAttribute('data-story-title'),
          url: panel.getAttribute('data-story-url'),
          image: panel.getAttribute('data-story-image'),
          series: panel.getAttribute('data-story-series'),
          status: button.getAttribute('data-passport-status'),
          savedAt: new Date().toISOString()
        };
        writeStore(PASSPORT_KEY, passport);
        select(passport[handle].status);
        updatePassportCount();
      });
    });
  }

  function initPassportDialog() {
    var dialog = document.querySelector('[data-passport-dialog]');
    if (!dialog) { updatePassportCount(); return; }
    var list = dialog.querySelector('[data-passport-list]');
    var empty = dialog.querySelector('[data-passport-empty]');
    function render() {
      var passport = readStore(PASSPORT_KEY);
      var stories = Object.keys(passport).map(function (key) { return passport[key]; }).sort(function (a, b) { return String(b.savedAt).localeCompare(String(a.savedAt)); });
      list.innerHTML = stories.map(function (story) {
        var image = story.image ? '<img src="' + escapeHtml(story.image) + '" alt="" loading="lazy">' : '';
        return '<article class="sl-passport-item">' + image + '<div><small>' + escapeHtml(story.series) + ' · ' + escapeHtml(story.status) + '</small><a href="' + escapeHtml(story.url) + '">' + escapeHtml(story.title) + '</a><button type="button" data-passport-remove="' + escapeHtml(story.handle) + '">Remove</button></div></article>';
      }).join('');
      empty.hidden = stories.length > 0;
      updatePassportCount();
    }
    document.querySelectorAll('[data-passport-open]').forEach(function (button) {
      button.addEventListener('click', function () { render(); if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); });
    });
    dialog.querySelector('[data-passport-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
      var remove = event.target.closest('[data-passport-remove]');
      if (!remove) return;
      var passport = readStore(PASSPORT_KEY);
      delete passport[remove.getAttribute('data-passport-remove')];
      writeStore(PASSPORT_KEY, passport);
      render();
    });
    render();
  }

  function normalizeArticleMedia() {
    var body = document.querySelector('[data-sl-body]');
    if (!body) return;
    var first = body.firstElementChild;
    if (first && first.matches('p') && first.querySelector('img') && !first.textContent.trim()) first.remove();

    Array.prototype.slice.call(body.querySelectorAll(':scope > p')).forEach(function (paragraph) {
      var image = paragraph.querySelector('img');
      if (!image) return;
      var media = image.closest('a') || image;
      if (media.parentNode !== paragraph) return;
      var nodes = Array.prototype.slice.call(paragraph.childNodes);
      var mediaIndex = nodes.indexOf(media);
      if (mediaIndex < 0) return;
      var before = nodes.slice(0, mediaIndex).filter(function (node) { return node.nodeName !== 'BR'; });
      var after = nodes.slice(mediaIndex + 1).filter(function (node) { return node.nodeName !== 'BR'; });
      var beforeText = before.map(function (node) { return node.textContent || ''; }).join('').trim();
      var afterText = after.map(function (node) { return node.textContent || ''; }).join('').trim();
      var fragment = document.createDocumentFragment();
      if (beforeText) {
        var intro = document.createElement('p');
        before.forEach(function (node) { intro.appendChild(node); });
        fragment.appendChild(intro);
      }
      var figure = document.createElement('figure');
      figure.className = 'sl-article-media';
      figure.appendChild(media);
      if (afterText) {
        var caption = document.createElement('figcaption');
        after.forEach(function (node) { caption.appendChild(node); });
        figure.appendChild(caption);
      }
      fragment.appendChild(figure);
      paragraph.replaceWith(fragment);
    });
  }

  function hideDuplicateNewsletters() {
    if (!document.querySelector('.sl-news, .sl2-news')) return;
    document.querySelectorAll('h2').forEach(function (heading) {
      if (heading.closest('.sl-news, .sl2-news')) return;
      if (heading.textContent.trim().toLowerCase() !== 'sign up to our newsletter') return;
      var section = heading.closest('.shopify-section-group-footer-group');
      if (section && section.id.indexOf('__newsletter_') !== -1) {
        section.hidden = true;
        return;
      }
      var column = heading.closest('[class*="space-y-5"]');
      if (column) column.hidden = true;
    });
  }

  ready(function () {
    normalizeArticleMedia();
    hideDuplicateNewsletters();
    initResponse();
    initStamp();
    initPassportDialog();
  });
})();
